import { CheckCircle2, Circle, HelpCircle, Loader, XCircle } from 'lucide-react'

import type { ReactNode } from 'react'

import type { StateBadgeVm } from '../port/types'

const ICONS: Readonly<Record<StateBadgeVm['icon'], ReactNode>> = {
  idle: <Circle size={16} aria-hidden="true" />,
  progress: <Loader size={16} aria-hidden="true" />,
  ok: <CheckCircle2 size={16} aria-hidden="true" />,
  failed: <XCircle size={16} aria-hidden="true" />,
  unknown: <HelpCircle size={16} aria-hidden="true" />,
}

/**
 * Состояние денег или чека: подпись, значок, рамка и слово — экран в
 * grayscale читается без цвета (CLAUDE.md §7).
 */
export function StateBadge({ badge }: { badge: StateBadgeVm }) {
  return (
    <p className="sale__badge" data-tone={badge.tone} data-icon={badge.icon}>
      {ICONS[badge.icon]}
      <span className="sale__badge-label">{badge.label}:</span> {badge.text}
    </p>
  )
}
